var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"kd-fragment",class:[_vm.typeClassName]},[_c('div',{staticClass:"kd-fragment__header"},[(this.$slots.header)?_vm._t("header"):(_vm.title)?_c('div',{staticClass:"kd-fragment__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()],2),_c('div',{staticClass:"kd-fragment__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }